import React from 'react';

const PriceIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.1777 18.5039L5.05469 10.4844V9.31641H8.64648C10.4902 9.31641 11.9883 7.81836 11.9883 5.97656C11.9883 4.13477 10.4883 2.63672 8.64648 2.63672H4.46875V1.46484H8.64648C9.85156 1.46484 10.9863 1.93359 11.8379 2.78516C12.6914 3.63672 13.1602 4.76953 13.1602 5.97656C13.1602 7.18359 12.6914 8.31641 11.8379 9.16797C10.9863 10.0195 9.85352 10.4883 8.64648 10.4883H6.53125L12.1094 17.793L11.1777 18.5039Z"
        fill="#1B2124"
      />
      <path
        d="M4.46875 5.52734H15.5234V6.69922H4.46875V5.52734ZM4.46875 1.46484H15.5234V2.63672H4.46875V1.46484Z"
        fill="#1B2124"
      />
    </svg>
  );
};

export default PriceIcon;
